<template>
    <div>
      <div class="card">
        <header class="header-card">
          <p>{{ $t('rapprochementAchat.infoFacture')}}</p>
        </header>
        <div class="card-content">
          <div class="columns">
            <div class="column is-3 ellipsis">
              <b-field :label="$t('rapprochementAchat.fournisseur')"
                       custom-class="is-italic"
              class="hex-text-default">
                <span class="has-text-weight-bold">{{ facture.intervenants.length === 1
                  ? facture.intervenants[0].nomCommercial : null }}</span>
              </b-field>
            </div>
            <div class="column is-3 ellipsis">
              <b-field :label="$t('rapprochementAchat.montantHtAffecter')"
              class="hex-text-default" custom-class="is-italic">
                <span class="has-text-weight-bold">{{ facture.montantHt | formatDevise }}</span>
              </b-field>
            </div>
            <div class="column is-3 ellipsis">
              <b-field :label="$t('rapprochementAchat.datePaiement')"
              class="hex-text-default" custom-class="is-italic">
                <span class="has-text-weight-bold">{{ getDatePaiement() | formatDate }}</span>
              </b-field>
            </div>
            <div class="column is-3 ellipsis">
              <b-field :label="$t('rapprochementAchat.modeReglement')"
              class="hex-text-default" custom-class="is-italic">
                <span class="has-text-weight-bold">
                  {{ getModeReglement(facture.modeReglementId) }}
                </span>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'InformationFactureBailleur',
  props: {
    facture: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getDatePaiement() {
      if (this.facture.echeancierPaiement.length === 0) return null;
      let minDate = moment(this.facture.echeancierPaiement[0].dateEcheance);
      this.facture.echeancierPaiement.forEach((echeance) => {
        if (moment(echeance.dateEcheance).isBefore(minDate)) {
          minDate = moment(echeance.dateEcheance);
        }
      });
      return minDate.toDate();
    },
    getModeReglement(id) {
      const modeReglementFind = this.parametre(PARAMETRES_KEYS.modeReglement)
        .find((modeReglement) => { return modeReglement.id === id; });
      return modeReglementFind ? modeReglementFind.libelle : '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
